import api from './api';

export interface PunctualTimeSlot {
  id: number;
  student: number;
  student_name: string;
  date: string;
  start_time: string;
  end_time: string;
  created_at: string;
  updated_at: string;
}

class PunctualTimeSlotService {
  async getAll(params?: any): Promise<PunctualTimeSlot[]> {
    const response = await api.get('/punctual-time-slots/', { params });
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getByWeek(dateFrom: string, dateTo: string): Promise<PunctualTimeSlot[]> {
    return this.getAll({ date_from: dateFrom, date_to: dateTo });
  }

  async create(data: Partial<PunctualTimeSlot>): Promise<PunctualTimeSlot> {
    const response = await api.post('/punctual-time-slots/', data);
    return response.data;
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/punctual-time-slots/${id}/`);
  }
}

const punctualTimeSlotService = new PunctualTimeSlotService();
export default punctualTimeSlotService;
